import styled from 'styled-components'

const Wrapper = styled.div`
  position: relative;
  width: 100%;
  img {
    overflow: visible;
    max-width: 100%;
  }
`
export const TrainingSize_Mobile = ({
  annotations,
}: {
  annotations?: React.ReactNode[]
}) => {
  console.log("MOB")
  return (
    <Wrapper>
      <img src={require('./trainingsize_mobile.png')} />
      {annotations &&
        annotations.map((anno) => {
          return <>{anno}</>
        })}
    </Wrapper>
  )
}
